// components/AccountTree.js
import React, { useState } from 'react';

const AccountNode = ({ account }) => {
  const [expanded, setExpanded] = useState(false);

  const hasChildren = account.children && account.children.length > 0;

  return (
    <div style={{ marginLeft: '20px' }}>
      <div
        style={{ cursor: hasChildren ? 'pointer' : 'default', display: 'flex', alignItems: 'center' }}
        onClick={() => hasChildren && setExpanded(!expanded)}
      >
        {hasChildren && (
          <span style={{ marginRight: '5px' }}>{expanded ? '▼' : '▶'}</span>
        )}
        <span>{account.code} - {account.name}</span>
      </div>
      {expanded && hasChildren && (
        <div>
          {account.children.map(child => (
            <AccountNode key={child.uuid} account={child} />
          ))}
        </div>
      )}
    </div>
  );
};

const AccountTree = ({ accounts }) => {
  return (
    <div>
      {accounts.map(account => (
        <AccountNode key={account.uuid} account={account} />
      ))}
    </div>
  );
};

export default AccountTree;
